export default "__VITE_ASSET__2320d5a0__"